import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { DespatchAdviceItem } from '../../data/models'
import i18n from '../../utils/i18n'

export const DeliveryStatusFilterTemplate = (options: any) => {
  if (!options) return null

  const deliveryStatus: DespatchAdviceItem['DeliveryStatus'][] = [
    'NOT_SET',
    'COMPLETE',
    'PARTLY',
  ]

  const valueTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <>{i18n.t(`common.codes.deliveryStatus.${option?.toLowerCase()}`)}</>
      )
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => {
    return <>{i18n.t(`common.codes.deliveryStatus.${option?.toLowerCase()}`)}</>
  }

  return (
    <Dropdown
      value={options.value}
      options={deliveryStatus}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchStatus')}
    />
  )
}
